import { useEffect, useState } from "react";
import { Loading } from "../../../../../Helper/Loading";
import { useAuthState } from "../../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import { DailyWorkChecklistProgressDashboardAPI } from "../../../../../Redux/DailyWorkChecklistProgress/DailyWorkChecklistProgressSlice";


export const STPOfficialVisitGrid = (props) => {
    const { Month, FinancialYear, AssetID } = props
    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [OpenModal, setOpenModal] = useState(false);
    const [Flag, setFlag] = useState("");
    const [officerData, setOfficerData] = useState(null)
    const [weekID, setWeekID] = useState("-")

    const handlePopupOpen = (data, week, type, desig) => {
        // console.log(desig)
        if (data && type === "VisitTarget" && desig === "Garden  Assistant") {
            setOfficerData(data)
            setWeekID(week)
            setFlag("VisitTarget")
            setOpenModal(true);
        }
        if (data && type === "Achievement") {
            setOfficerData(data)
            setWeekID(week)
            setFlag("Achievement")
            setOpenModal(true);
        }

        // if (data && type === "Pending" && desig === "Garden  Assistant") {
        //   setOfficerData(data)  
        //   setWeekID(week)
        //   setFlag("Pending")
        //   setOpenModal(true);
        // }

    };

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: FinancialYear,
            M_MonthID: Month,
            M_ZoneID: "-",
            M_WardID: "-",
            M_AssetTypeID: AssetID,
            M_WorkTypeID: "-",
            M_UsersID: UserID,
            Flag: "Garden",
            token: token,

        }
        // dispatch(DailyWorkChecklistProgressDashboardAPI({ data }))
    }, [AssetID, FinancialYear, Month])

    // const { mainHeading, heading, tableData, isLoading } = useSelector(state => state.DailyWorkChecklistProgressDashboardSliceData)

    const tableData = {
        "code": 200,
        "status": true,
        "message": "Successful",
        "mainHeading": [
            {
                "manihead": "Officer Details",
                "no": 3
            },
            {
                "manihead": "1st Week",
                "no": 3
            },
            {
                "manihead": "2nd Week",
                "no": 3
            },
            {
                "manihead": "3rd Week",
                "no": 3
            },
            {
                "manihead": "4th Week",
                "no": 3
            },
            {
                "manihead": "5th Week",
                "no": 3
            },
            {
                "manihead": "Total",
                "no": 4
            }
        ],
        "heading": [
            // {
            //     "head": "Project Name"
            // },
            {
                "head": "Designation"
            },
            {
                "head": "Officer Name"
            },
            {
                "head": "Ward"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },
            {
                "head": "Target"
            },
            {
                "head": "Achieve."
            },
            {
                "head": "Pending"
            },

        ],
        "data": [
            {
                "designationName": "E.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 100,
                        "employeeName": "Deepak Suryarao",
                        "m_UserID": 154,
                        "m_WardID": "-",
                        "wardName": "All",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    },
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Mr.Pnadharinath",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Airoli",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Mr.Vaibhav thorat",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Airoli",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "-",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Belapur",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "-",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Belapur",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Kailas Gaikwad",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Ghansoli",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Vaibhav Thorat",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Ghansoli",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Mr.Pnadharinath",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "koparkhairane",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Mr.Vaibhav thorat",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "koparkhairane",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Swpanil Desai",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Nerul",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Santosh Unawane",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Nerul",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Dilip Benake",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Nerul",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Abhay Gawit",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Nerul",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Deepak Suryarao",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Turbhe",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Nikhil Kale",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Turbhe",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Swpanil Desai",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Vashi",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "D.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Santosh Unawane",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Vashi",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Dilip Benake",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Vashi",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
            {
                "designationName": "J.E",
                "noofrow": 2,
                "rowdata": [
                    {
                        "m_EmployeeID": 151,
                        "employeeName": "Abhay Gawit",
                        "m_UserID": 155,
                        "m_WardID": "-",
                        "wardName": "Vashi",
                        "week1_VisitTarget": "-",
                        "week1_Achievement": "-",
                        "week1_Pending": "-",
                        "week2_VisitTarget": "-",
                        "week2_Achievement": "-",
                        "week2_Pending": "-",
                        "week3_VisitTarget": "-",
                        "week3_Achievement": "-",
                        "week3_Pending": "-",
                        "week4_VisitTarget": "-",
                        "week4_Achievement": "-",
                        "week4_Pending": "-",
                        "week5_VisitTarget": "-",
                        "week5_Achievement": "-",
                        "week5_Pending": "-",
                        "total_VisitTarget": "-",
                        "total_Achievement": "-",
                        "total_Pending": "-"
                    }
                ]
            },
        ]
    }

    return (
        <>
            {/* {isLoading && <Loading />} */}
            <div
                className="row m-0 p-0  bg-white"
                style={{
                    border: "1px solid #0d467ee6",
                    borderRadius: "8px ",
                    width: "100%",
                    overflow: "scroll",
                }}
            >
                <div className="col-12 pt-3 pb-0 m-1">
                    <table
                        id="totalordergenerated"
                        cellPadding="0"
                        cellSpacing="0"
                        border="0"
                        className="table table-bordered "
                        style={{ textAlign: "center" }}
                    >
                        <thead className="gardenworktable" id="customers">
                            <tr className="text-center ">
                                <th colSpan={22} className="text-center fw-bold fs-6 py-2" style={{ background: '#048a8b' }}>STP Daily Work Schedule</th>
                            </tr>

                            <tr className="text-center tablethhead2">
                                {tableData?.mainHeading &&
                                    tableData?.mainHeading.map((i) => {
                                        return (
                                            <th
                                                colSpan={i.no}
                                                className="text-center fw-bold fs-6"
                                                id="tablecolor"
                                            >
                                                {i.manihead}
                                            </th>
                                        );
                                    })}
                            </tr>

                            <tr
                                className="text-center gardenworkth"
                                style={{ width: "100%" }}
                            >
                                {tableData?.heading &&
                                    tableData?.heading.map((j) => {
                                        // <></>
                                        return (
                                            <th
                                                className="text-center fw-bold"
                                                style={{ whiteSpace: "nowrap" }}
                                            >
                                                {j.head}
                                            </th>
                                        );
                                    })}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.data?.map((designation) => {
                                return designation.rowdata?.map((officer, officerIndex) => {
                                    const rowSpan = designation.rowdata?.length || 1;
                                    return (
                                        <tr
                                            className="text-center"
                                            key={`${designation.designationName}-${officerIndex}`}
                                        >
                                            {officerIndex === 0 ? (
                                                <td className="text-center" rowSpan={rowSpan} >
                                                    {designation.designationName}
                                                </td>
                                            ) : null}

                                            <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{officer.wardName}</td>

                                            {/* Week 1 */}
                                            <td role="button" onClick={() => handlePopupOpen(officer, 1, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week1_VisitTarget}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 1, "Achievement")} className="greencolorCount text-center">{officer.week1_Achievement}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 1, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week1_Pending}</td>

                                            {/* Week 2 */}
                                            <td role="button" onClick={() => handlePopupOpen(officer, 2, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week2_VisitTarget}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 2, "Achievement")} className="greencolorCount text-center">{officer.week2_Achievement}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 2, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week2_Pending}</td>

                                            {/* Week 3 */}
                                            <td role="button" onClick={() => handlePopupOpen(officer, 3, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week3_VisitTarget}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 3, "Achievement")} className="greencolorCount text-center">{officer.week3_Achievement}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 3, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week3_Pending}</td>

                                            {/* Week 4 */}
                                            <td role="button" onClick={() => handlePopupOpen(officer, 4, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week4_VisitTarget}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 4, "Achievement")} className="greencolorCount text-center">{officer.week4_Achievement}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 4, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week4_Pending}</td>

                                            {/* Week 5 */}
                                            <td role="button" onClick={() => handlePopupOpen(officer, 5, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week5_VisitTarget}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 5, "Achievement")} className="greencolorCount text-center">{officer.week5_Achievement}</td>
                                            <td role="button" onClick={() => handlePopupOpen(officer, 5, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week5_Pending}</td>

                                            {/* Totals */}
                                            <td className="bluecolorCount text-center">{officer.total_VisitTarget}</td>
                                            <td className="greencolorCount text-center">{officer.total_Achievement}</td>
                                            <td className="orangecolorCount text-center">{officer.total_Pending}</td>



                                            {/* KPI Assign (optional) */}

                                        </tr>
                                    );
                                });
                            })}
                        </tbody>

                    </table>
                </div>
            </div>

            {/* {OpenModal &&
        <VisitTargetWeekModal
          handleOpenModal={handlePopupOpen}
          ApiFlag={Flag}
          handleCloseModal={handleCloseModal}
          weekID={weekID}
          officerData={officerData}
          FinancialYear={FinancialYear}
          Month={Month}
        />
      } */}
        </>
    )
}

